import { updateURL, removeQueryStringParameter, QueryString, objectToUrlQuery, toFixed } from '../functions';
import Swal from 'sweetalert2';


$(document).ready(function() {

	$(document).on('click', '.change-car-btn', function(e) {
		var parameters = QueryString(null);

		delete parameters.group;
		delete parameters.insurance;
		delete parameters.extras;

		var url = objectToUrlQuery(parameters);
		window.location = selectCarRoute + (url != '' ? '?' + url : '');
	});

	try {
		if(selectedInsuranceCode != null) {
			updateURL('select-extras', 'Select Extras', 'insurance', selectedInsuranceCode);
		}
	} catch (e) {

	} finally {

	}

	/*$(document).on('click', '.insurance-item', function(e) {
		e.preventDefault();

		let code = $(this).data('code');
		let title = $(this).data('title');
		let price = $(this).data('price');
		let warranty = $(this).data('warranty');

		// $('.depozit-info span').html(warranty + ' &euro;');
		// $('.depozit-info').show();

		var index = insurancesValues.indexOf(code);
	    if (index == -1) {
	        $(this).addClass('active');
	        insurancesValues.push(code);
	    } else {
	        $(this).removeClass('active');
	        insurancesValues.splice(index, 1);
	    }

		if (insurancesValues.length > 0) {
	        updateURL('select-insurance', 'Select insurance', 'insurance', insurancesValues.join(','));
	    } else {
	        var newURL = removeQueryStringParameter('insurance', window.location.href);
	        history.replaceState({ id: 'select-insurance' }, 'Select Extras', newURL);
	    }

		if ($('#group-insurance-' + code).length > 0) {
			$('#group-insurance-' + code).remove();
		} else {
			var extraHtml = '<li id="group-insurance-'+code+'" class="fw-bold d-flex align-items-center">' +
								'<i class="fas fa-check me-2"></i> '+title+' <span class="ms-auto">'+price+' &euro;</span>' +
							'</li>';
			$('#group-insurances-wrapper').append(extraHtml);
		}

		let newTotal = calculateTotal(total);
		$('#total').html(newTotal);
	});*/

	$(document).on('click', '.insurance-item', function(e) {
		e.preventDefault();

		let code = $(this).data('code');
		let title = $(this).data('title');
		let price = $(this).data('price');
		let warranty = $(this).data('warranty');
		var icon = $(this).data('icon');

		$('.depozit-info').text(warranty);

		$('.insurance-item').removeClass('active');

		$(this).addClass('active');
		// $('#total').html(total+(1*price));

		updateURL('select-extras', 'Select Extras', 'insurance', code);

		var extraHtml = '<li id="group-insurance-'+code+'">' +
							'<span class="left"><i class="fa fa-check" aria-hidden="true"></i> '+title+'</span><span class="right price-small">&euro; '+price+'</span><div class="clearfix"></div>' +
						'</li>';
						
		var extraHtml = `<li id="group-insurance-${code}">
							<img src="${icon}" alt="" />
							<div class="bm-totalcost_title">
								<h5>${title}</h5>
								<h6>&euro;${price}</h6>
							</div>
						</li>`;
		
		$('#group-insurances-wrapper').html(extraHtml);

		let newTotal = calculateTotal(total);
		$('#total').html(newTotal);
	});

	$(document).on('click', '.extra-item', function(e) {
		e.preventDefault();
		if($(e.target).hasClass('mobile-extra-qty')) {
			return false;
		}

		var code = $(this).data('code');
		var title = $(this).data('title');
		var price = $(this).data('price');
		var icon = $(this).data('icon');
		var qty = $(this).attr('data-qty');
		price = price * qty;

		var index = extrasValues.indexOf(code);
	    if (index == -1) {
	        $(this).addClass('active');
	        extrasValues.push(code);
			//$('#extra-qty-wrapper-' + code).show();
			//$('#mobile-extra-qty-' + code).val(1);
			//update price
			//total = total + 1*price;
			//$('#total').html(total);
	    } else {
	        $(this).removeClass('active');
	        extrasValues.splice(index, 1);
			//$('#extra-qty-wrapper-' + code).hide();
			//$('#mobile-extra-qty-' + code).val(0);
			//update price
			//total = total - 1*price;
			//$('#total').html(total);
	    }

	    if (extrasValues.length > 0) {
	        updateURL('select-extras', 'Select Extras', 'extras', extrasValues.join(','));
	    } else {
	        var newURL = removeQueryStringParameter('extras', window.location.href);
	        history.replaceState({ id: 'select-extras' }, 'Select Extras', newURL);
	    }

		if ($('#group-extra-' + code).length > 0) {
			$('#group-extra-' + code).remove();
		} else {
			var extraIconHtml = '';
			if (icon != '') {
				extraIconHtml = `<img src="${icon}" alt="" />`;
			}
			var extraHtml = `<li id="group-extra-${code}">
								${extraIconHtml}
								<div class="bm-totalcost_title">
									<h5>${title}</h5>
									<h6>&euro;${price}</h6>
								</div>
							</li>`;
			$('#group-extras-wrapper').append(extraHtml);
		}

		let newTotal = calculateTotal(total);
		$('#total').html(newTotal);
	});

	$(document).on('click', '#send-reservation', function(e) {
        e.preventDefault();

        var parameters = QueryString(null);

		// if(!parameters.insurance || parameters.insurance == '') {
		// 	Swal.fire({
		// 		icon: 'error',
		// 		title: 'Oops...',
		// 		text: alertSelectInsurance
		// 	})
		// 	return false;
		// }

        var url = objectToUrlQuery(parameters);

        window.location = reservationRoute + (url != '' ? '?' + url : '');
    });

	$(document).on('click', '.extra-qty-plus', function(e) {
		e.preventDefault();
		e.stopPropagation();

		let code = $(this).data('code');
		if (code == null) {
			console.error('invalid code');
			return false;
		}

		if($('#extra-item-' + code).length > 0) {
			let maxQty = $('#extra-item-' + code).attr('data-max-qty');
			let price = $('#extra-item-' + code).data('price');
			let qty = $('#extra-item-' + code).attr('data-qty');
			qty++;

			if (1*qty > 1*maxQty) {
				console.info('max qty');
				return false;
			}

			$('#extra-item-' + code).attr('data-qty', qty);
			$('#extra-qty-' + code).html(qty);
			$('.selected-extra-qty-' + code).html(qty);
			$('.selected-extra-price-' + code + ' span').html(price * qty);

			let newTotal = calculateTotal(total);
			$('#total').html(newTotal);

			setExtraQty(code, qty);

			return;
		}

		console.error('element-not-found');
	});

	$(document).on('click', '.extra-qty-minus', function(e) {
		e.preventDefault();
		e.stopPropagation();

		let code = $(this).data('code');
		if (code == null) {
			console.error('invalid code');
			return false;
		}

		if($('#extra-item-' + code).length > 0) {
			let price = $('#extra-item-' + code).data('price');
			let qty = $('#extra-item-' + code).attr('data-qty');
			qty--;
			if(qty < 1) {
				qty = 1;
			}

			$('#extra-item-' + code).attr('data-qty', qty);
			$('#extra-qty-' + code).html(qty);
			$('.selected-extra-qty-' + code).html(qty);
			$('.selected-extra-price-' + code + ' span').html(price * qty);

			let newTotal = calculateTotal(total);
			$('#total').html(newTotal);

			setExtraQty(code, qty);

			return;
		}

		console.error('element-not-found');
	});

	$(document).on('click', '.extra-qty', function(e) {
		e.stopPropagation();
	});
});

window.onpopstate = function(event) {
	console.log(`location: ${document.location}, state: ${JSON.stringify(event.state)}`);
}

function calculateTotal(total) {

	if (QueryString(null).insurance) {
		let insurances = QueryString(null).insurance.split(',');
		if (insurances.length > 0) {
			for (var i = 0; i < insurances.length; i++) {
				if ($('#insurance-item-' + insurances[i]).length > 0) {
					let price = $('#insurance-item-' + insurances[i]).data('price');
					total += 1*price;
				}
			}
		}
	}

	if (QueryString(null).extras) {
		let extras = QueryString(null).extras.split(',');
		if (extras.length > 0) {
			for (var i = 0; i < extras.length; i++) {
				if ($('#extra-item-' + extras[i]).length > 0) {
					let price = $('#extra-item-' + extras[i]).data('price');
					let qty = $('#extra-item-' + extras[i]).attr('data-qty');
					total += 1*price * qty;
				}
			}
		}
	}

	fees.forEach(function (fee) {
		total += 1*fee.price * fee.quantity;
	});

	return toFixed(total, 2);
}

function setExtraQty(code, qty) {
	var values = 'code=' + code;
	values += '&qty=' + qty;
	$.ajax({
		type: "GET",
		url: baseURL + "/set-extra-qty",
		data: values,
		success: function(response) {

		},
		error(error) {

		}
	});
}

$(document).ready(function() {

	const groupPage = {
        isLoading: false,
        init() {
            $(document).on('click', '.search-calendar-trigger', this, this.showCalendar);

			$(document).on('change', '#from-time', function() {
				var parameters = QueryString(null);

				//$('#to-time').select2("val", $('#from-time option:selected').val());

				parameters.pd = $('#date-from').val() + '-' + $('#from-time option:selected').val();
				parameters.rd = $('#date-to').val() + '-' + $('#to-time option:selected').val();

				var url = objectToUrlQuery(parameters);

				window.location = selectExtrasRoute + (url != '' ? '?' + url : '');
			});

			$(document).on('change', '#to-time', function() {
				var parameters = QueryString(null);

				//$('#to-time').select2("val", $('#from-time option:selected').val());

				parameters.pd = $('#date-from').val() + '-' + $('#from-time option:selected').val();
				parameters.rd = $('#date-to').val() + '-' + $('#to-time option:selected').val();

				var url = objectToUrlQuery(parameters);

				window.location = selectExtrasRoute + (url != '' ? '?' + url : '');
			});

			$(document).on('change', '#pickup_location', function() {
				var parameters = QueryString(null);

				if ($('#pickup_location option:selected').val() != '') {
					parameters.pl = $('#pickup_location option:selected').val();
				} else {
					delete parameters.pl;
				}

				var url = objectToUrlQuery(parameters);

				window.location = selectExtrasRoute + (url != '' ? '?' + url : '');
			});

			$(document).on('change', '#return_location', function() {
				var parameters = QueryString(null);

				if ($('#return_location option:selected').val() != '') {
					parameters.rl = $('#return_location option:selected').val();
				} else {
					delete parameters.rl;
				}

				var url = objectToUrlQuery(parameters);

				window.location = selectExtrasRoute + (url != '' ? '?' + url : '');
			});

			
        },
		showCalendar(event) {
			const _this = event.data;
			event.preventDefault();

			var type = $(this).data('type')
			var days = $(this).data('days')
			var element = this;

			var date = moment($('#date-from').val(), 'DD/MM/YYYY')
			if (type == 1) {
				date = moment($('#date-to').val(), 'DD/MM/YYYY')
			}

			$('#modal-calendar').modal('show');
			$('#modal-calendar').on('shown.bs.modal', function (e) {
				// $('#calendar-wrapper').removeClass('visually-hidden');
				// $('.daterangepicker').css("display", "block");

				$('#calendar-place').daterangepicker({
					alwaysShowCalendars: true,
					minDate: moment().add(2, 'hours'),
					startDate: date,
					//minDate: moment().add(1, 'days'),
					// startDate: moment().add(1, 'days'),
					// endDate: moment().add(3, 'days'),
					autoApply: true,
					autoUpdateInput: false,
					singleDatePicker: true,
					locale: {
						format: 'DD/MM/YYYY'
					}
				});

				$('#calendar-place').on('apply.daterangepicker', function(ev, picker) {
					var startDate = picker.startDate;
					//var endDate = picker.endDate;

					$(element).html(startDate.format('DD/MM/YYYY'));

					if (type == 0) {
						$('#date-from').val(startDate.format('DD/MM/YYYY'));
						var toDate = startDate.add(days, 'days');
						$('#date-to').val(toDate.format('DD/MM/YYYY'));
						$('.date-to-btn').text(toDate.format('DD/MM/YYYY'));
					} else {
						$('#date-to').val(startDate.format('DD/MM/YYYY'));
					}

					$('#modal-calendar').modal('hide');

					let parameters = QueryString(null);

					parameters.pd = $('#date-from').val() + '-' + $('#from-time option:selected').val();
					parameters.rd = $('#date-to').val() + '-' + $('#to-time option:selected').val();

					var url = objectToUrlQuery(parameters);
					window.location = selectExtrasRoute + (url != '' ? '?' + url : '');
				});
			});
		},
    };

    if ($('.group-page-container').length) {
        groupPage.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/group.js